import React from 'react';
import { IframeUtility } from '@inter-ikea-kompis/utilities';

// Some browsers (mainly IE) does not have this property, so we need to build it manually...
export const origin = window.location.origin || `${window.location.protocol}//${window.location.hostname}${window.location.port ? (`:${window.location.port}`) : ''}`;
import { upptackaEnabled } from 'app';
const sendMessage = (name, body) => {
  const msg = {
    header: {
      name,
    },
    body: {
      containerName: '#cwcalc-application',
      ...body,
    },
  };

  window.parent.postMessage(msg, origin);
};

export const getContentHeight = () => {
  const body = document.body;
  const html = document.documentElement;
  return Math.max(body.offsetHeight, html.offsetHeight);
};

export const resize = (heightChange = 0, onlyParam) => {
  if (!upptackaEnabled) {
    console.log("resize getContentHeight() is: ", getContentHeight());
    if (onlyParam) {
      sendMessage('setContainerSize', { height: heightChange });
    } else {
      sendMessage('setContainerSize', { height: getContentHeight() + heightChange });
    }
  }
};

export const setWindowYPosition = (yPos = 0) => {
  window.top.scrollTo({
    top: yPos,
    behavior: 'smooth'
  });
};

export const goToElement = (element) => {
  
  if (element) {
    IframeUtility.scrollToElement({ element: element, animate: true });
  } else {
    console.log("Iframe goToElement() - element not found!");
  }
};

export const getOffset = (cb) => {
  sendMessage('getContainerOffset', { });
  listenOnce(({ data }) => cb(data), ({ data }) => Array.isArray(data) && data.length === 4);
};

export const isFramed = window.top !== window.self;

export const isRTL = () => {  
  const body = document.body;
  return body.dir =='rtl';
};

export const hideIfFramed = (Component) => (props) => {
  const { isFramed, cwcalcReachedFromIpexGallery, cwcalcReachedFromUpptacka } = props;

  if (isFramed && !(cwcalcReachedFromIpexGallery || cwcalcReachedFromUpptacka)) {
    return null;
  }

  return <Component {...props} />;
};

const withFrameResizeBuilder = (onUpdate, onMount) => (Component) => {
  if (!isFramed) {
    return Component;
  }

  return class FramedComponent extends React.Component {
    static displayName = `framed(${(Component.displayName || Component.name || 'Component')})`;

    componentDidMount() {
      if (onMount) {
        setTimeout(() => {
          // Run code
          resize();
        }, 2000);
        
      }
    }

    componentDidUpdate() {
      if (onUpdate) {
        setTimeout(() => {
          // Run code
          resize();
        }, 1000);
        
      }
    }

    render() {
      return <Component {...this.props} />;
    }
  };
};

export const withFrameResize = withFrameResizeBuilder(true, true);
export const withFrameResizeOnMount = withFrameResizeBuilder(false, true);

const listenOnce = (cb, predicate) => {
  subscribers.push({ cb, predicate });
};

let subscribers = [];

if (isFramed) {
  const listener = (event) => {
    const subscriber = subscribers.find(({ predicate }) => predicate(event));

    if (subscriber) {
      subscriber.cb(event);
      subscribers = subscribers.filter((s) => s !== subscriber);
    }
  };

  if (window.addEventListener) {
    window.addEventListener('message', listener, false);
  } else if (window.attachEvent) {
    window.attachEvent('onmessage', listener);
  }
}
